import React from "react";
import { CalendarDays, MapPin, Clock } from "lucide-react";
import { Reveal, Kicker, WfButton, Tag, ImageWithCredit } from "@/components/site/primitives";
import { EVENT } from "@/content/worldFarmers";

export const UpcomingEvents = () => (
  <section id="events" aria-labelledby="events-heading" className="wf-section bg-[var(--wf-cream)]">
    <div className="wf-container">
      <Reveal className="max-w-2xl">
        <Kicker>What’s happening</Kicker>
        <h2 id="events-heading" className="mt-3 font-serif text-3xl font-semibold text-[var(--wf-ink)] sm:text-4xl">
          Upcoming events
        </h2>
        <p className="mt-3 text-base leading-7 text-muted-foreground">
          Come out to the farm and meet the community behind the harvest.
        </p>
      </Reveal>

      <Reveal delay={0.08}>
        <article
          data-testid="events-featured-event-card"
          className="mt-10 grid grid-cols-1 overflow-hidden rounded-sm border border-[var(--wf-border)] bg-[var(--wf-paper)] shadow-[var(--wf-shadow-sm)] lg:grid-cols-2"
        >
          {/* Image + date badge */}
          <div className="relative">
            <ImageWithCredit
              src={EVENT.image}
              alt={EVENT.alt}
              className="h-full min-h-[260px]"
              imgClassName="h-full"
            />
            <div className="absolute right-4 top-4 z-[2] flex flex-col items-center rounded-sm bg-[var(--wf-maroon)] px-4 py-3 text-[var(--wf-paper)] shadow-[var(--wf-shadow)]">
              <span className="text-xs font-semibold uppercase tracking-[0.16em]">{EVENT.dateParts.month}</span>
              <span className="font-serif text-3xl font-semibold leading-none">{EVENT.dateParts.day}</span>
              <span className="text-xs tracking-wide opacity-90">{EVENT.dateParts.year}</span>
            </div>
          </div>

          {/* Details */}
          <div className="flex flex-col justify-center gap-4 p-6 sm:p-8">
            <Tag className="w-fit">{EVENT.badge}</Tag>
            <h3 className="font-serif text-2xl font-semibold text-[var(--wf-ink)] sm:text-3xl">
              {EVENT.title}
            </h3>
            <ul className="flex flex-col gap-2 text-sm text-muted-foreground">
              <li className="flex items-center gap-2"><CalendarDays className="h-4 w-4 text-[var(--wf-green-text)]" aria-hidden="true" />{EVENT.date}</li>
              <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[var(--wf-green-text)]" aria-hidden="true" />{EVENT.location}</li>
            </ul>
            <p className="text-sm leading-6 text-muted-foreground">{EVENT.body}</p>
            <div className="mt-1 flex flex-wrap items-center gap-3">
              <WfButton as="a" href={EVENT.href} withArrow data-testid="events-featured-event-cta-button">
                {EVENT.cta}
              </WfButton>
              <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
                <Clock className="h-3.5 w-3.5" aria-hidden="true" />{EVENT.ticketingNote}
              </span>
            </div>
          </div>
        </article>
      </Reveal>
    </div>
  </section>
);
